import {PushOptions} from "../core/types";
import {waitForDataLayer} from "../adapters/dataLayerAdapter";

let previousPageReferrer: string = (typeof document !== 'undefined') ? document.referrer : '';

export async function dataLayerPageView(url?: string, campaignId?: string | null, channelId?: string | null, _options?: PushOptions) {
    if (typeof window === "undefined") return;
    await waitForDataLayer();

    const hostname = (typeof window !== 'undefined' && (window as any).location) ? (window as any).location.hostname : '';
    const page_path = url ?? (typeof window !== 'undefined' ? (window as any).location?.pathname : '');
    const page_referrer = previousPageReferrer;
    const page_title = (typeof document !== 'undefined') ? document.title : '';

    const win = window as any;
    win.dataLayer = win.dataLayer || [];
    win.dataLayer.push({
        event: 'gx.page_view',
        event_name: 'page_view',
        event_source: 'source_code',
        hostname,
        page_path,
        page_referrer,
        page_title,
        campaign_id: campaignId ?? null,
        channel_id: channelId ?? null,
    });

    // update referrer to current url for next navigation
    previousPageReferrer = url ?? (typeof window !== 'undefined' ? (window as any).location?.pathname : '');
}